import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "planInput"];

  open(event) {
    if (event) {
      event.preventDefault();
    }

    const trigger = event?.currentTarget;
    const plan = trigger?.dataset?.subscriptionModalPlanParam || "";

    if (this.hasPlanInputTarget) {
      this.planInputTarget.value = plan;
    }

    if (typeof this.dialogTarget.showModal === "function") {
      this.dialogTarget.showModal();
    } else {
      this.dialogTarget.setAttribute("open", "");
    }
    document.body.style.overflow = "hidden";

    this.recordHeroExperimentConversion();
  }

  // Records a field_test conversion for the hero_image A/B test the first time
  // this visitor opens the modal. Fire-and-forget; never blocks the UI.
  recordHeroExperimentConversion() {
    if (this.converted) return;
    this.converted = true;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch("/field_test/hero_image/convert", {
      method: "POST",
      headers: { "X-CSRF-Token": token || "" },
      keepalive: true,
    }).catch(() => {
      // Ignore network errors — analytics must never break the modal.
      this.converted = false;
    });
  }

  close() {
    if (typeof this.dialogTarget.close === "function") {
      this.dialogTarget.close();
    } else {
      this.dialogTarget.removeAttribute("open");
    }
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close();
    }
  }

  onClose() {
    document.body.style.overflow = "";
  }
}
